import React, { ReactElement } from 'react';
import { DialogActions, Typography } from '@material-ui/core';
import { Alert, Button } from '@payactive/app-common';
import { BaseRow } from 'react-csv-importer';
import { useTranslation } from 'react-i18next';

interface Props {
  rows: BaseRow[];
  paymentsToImport: number;
  onFinish: () => void;
}

export default function Summary({ rows, paymentsToImport, onFinish }: Props): ReactElement {
  const { t } = useTranslation(['global', 'payments']);

  return (
    <div>
      {paymentsToImport === rows.length && (
        <Alert severity="success">
          <Typography>{t('payments:import.success', { num: rows.length })}</Typography>
        </Alert>
      )}
      {paymentsToImport > rows.length && rows.length !== 0 && (
        <Alert severity="warning">
          <Typography>{t('payments:import.warn', { created: rows.length, imported: paymentsToImport })}</Typography>
        </Alert>
      )}
      {rows.length === 0 && (
        <Alert severity="error">
          <Typography>{t('payments:import.error')}</Typography>
        </Alert>
      )}
      <DialogActions>
        <Button label={t('global:close')} name="import" onClick={onFinish} />
      </DialogActions>
    </div>
  );
}
